module.exports = __webpack_public_path__ + "static/media/0021_IMG_BVP.3d57eb87.png";